export const PRIVATE_DATABASE = 'privateDatabase'
